<template>
  <li class="li-call dropdown" :class="[statusIcon,show?'show':null]">
    <a class="dropdown-toggle" href="javascript:;" @click="show=!show">
      <span class="icon-phone-call"></span><i class="c-user-status" :class="$store.state.phoneIdle?null:'active'"></i>
    </a>
    <div class="dropdown-menu is-custom dropdown-menu-right" :class="show?'show':null">
      <div class="dropdown-menu__inner">
        <div class="dropdown-menu__padding">
          <div class="dropdown-menu__row">
            <div class="row">
              <div class="col-7">{{ $t('phoneStatus') }}</div>
              <div class="col-5 text-right">
                <div :class="statusBadge" class="badge">{{ $t($store.state.phoneStatus) }}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-8">{{ $t('readyToReceiveCall') }}</div>
              <div class="col-4 text-right">
                <div class="toggle">
                  <label>
                    <input v-model="available" type="checkbox"><span class="button-indecator"></span>
                  </label>
                </div>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-8">{{ $t('videoCallEnabled') }}</div>
              <div class="col-4 text-right">
                <div class="toggle">
                  <label>
                    <input v-model="$store.state.videoCallEnabled" type="checkbox"><span class="button-indecator"></span>
                  </label>
                </div>
              </div>
            </div> -->
          </div>
          <div class="dropdown-menu__row c-sound-config clearfix">
            <div class="c-sound-config__label">{{ $t('callerNumber') }}:</div>
            <div class="c-sound-config__select">
              <select v-model="$store.state.callerNumber" class="form-control form-control-sm custom-select">
                <option value="">{{ $t('default') }}</option>
                <option v-for="n in numbers" :key="n" :value="n">{{ n }}</option>
              </select>
            </div>
          </div>
          <div class="c-line-gadient"></div>
          <div v-if="!$store.state.inApp">
            <div class="dropdown-menu__row">
              <div class="row">
                <div class="col-7">
                  <label class="dropdown-menu__label">{{ $t('callCondition') }}</label>
                </div>
                <div class="col-5 text-right">
                  <button @click="check" :disabled="checking" class="btn btn-outline-gray btn-sm is-border-1" type="button">
                    <b-spinner v-if="checking" small></b-spinner>
                    <i v-else class="icon12-refesh-primary"></i>
                  </button>
                </div>
              </div>
            </div>
            <b-progress v-if="checking" :striped="true" variant="success" :max="100" height="15px" class="c-connect-progress progress">
              <b-progress-bar :value="checked" :label="`${checked}/100%`"></b-progress-bar>
            </b-progress>
            <div v-if="checking" class="alert alert-warning">
              <b-spinner small variant="info" class="mr-2"></b-spinner>
              <span>{{ $t('checking') }}: {{ $t(checkStepMsg) }}</span>
            </div>
            <div class="c-connect-list" v-if="checkResults.length || checking">
              <div v-for="result in checkResults" :key="result.step" class="c-connect-item" :class="resultStatusIcon(result.status)">
                <span class="c-connect-item__status">{{ $t(result.status) }}</span>
                <span class="c-connect-item__text">{{ result.msg }}</span>
              </div>
            </div>
            <div v-else class="alert alert-danger">
              <span>{{ $t('notChecked') }}</span>
            </div>
            <div class="c-line-gadient"></div>
          </div>
        </div>
        <div class="c-call-screen" v-if="$store.state.user.role !== 'nvyt'">
          <div class="c-call-screen__row">
            <div class="c-call-number">
              <input class="c-call-number__text" v-model="toNumber" :placeholder="$t('numberToCall')"/>
              <button class="c-call-number__back" @click="delNum"><i class="fa fa-times"></i></button>
            </div>
          </div>
          <div class="c-call-screen__row">
            <div class="c-push-number">
              <ul class="clearfix">
                <li>
                  <button @click="num('1')">1</button>
                </li>
                <li>
                  <button @click="num('2')">2</button>
                </li>
                <li>
                  <button @click="num('3')">3</button>
                </li>
                <li>
                  <button @click="num('4')">4</button>
                </li>
                <li>
                  <button @click="num('5')">5</button>
                </li>
                <li>
                  <button @click="num('6')">6</button>
                </li>
                <li>
                  <button @click="num('7')">7</button>
                </li>
                <li>
                  <button @click="num('8')">8</button>
                </li>
                <li>
                  <button @click="num('9')">9</button>
                </li>
                <li>
                  <button @click="num('*')">*</button>
                </li>
                <li>
                  <button @click="num('0')">0</button>
                </li>
                <li>
                  <button @click="num('#')">#</button>
                </li>
              </ul>
            </div>
          </div>
          <div class="c-call-screen__row">
            <button @click="checkDecree91" class="btn btn-primary btn-block btn-lg" type="button">{{ $t('call') }}</button>
          </div>
        </div>
        <!-- c-call-screen-->
        <b-modal v-model="showDecree91" title="Cảnh báo">
          <div class="alert alert-warning">
            Cảnh báo: Theo nghị định 91, không thực hiện cuộc gọi quảng cáo trước 8h và sau 17h!
          </div>
          <form-checkbox :model="decree91" attribute="check" chk-label="Tôi chắc chắn đây không phải cuộc gọi quảng cáo"></form-checkbox>
          <template v-slot:modal-footer>
            <button class="btn btn-secondary" @click="showDecree91 = false">{{ $t('cancel') }}</button>
            <button class="btn btn-primary" :disabled="!decree91.check" @click="makeCall">
              {{ $t('call') }}
            </button>
          </template>
        </b-modal>
      </div>
    </div>
  </li>
</template>

<script>
import WebRTCTest from './webrtc-test';
import console from 'console';
import moment from "moment";

export default {
  data: function () {
    return {
      show: false,
      toNumber: '',
      numbers: [],
      checking: false,
      checked: 0,
      checkStepMsg: null,
      checkResults: [],
      checkInterval: null,
      showDecree91: false,
      available: true,
      videoCallEnabled: false,
      decree91: {
        check: true
      }
    }
  },
  watch: {
    available(val) {
      this.$store.commit('phoneIdle', !val);
    },
  },
  computed: {
    statusBadge() {
      if (this.$store.state.phoneStatus === 'connected') {
        return 'badge-success';
      }
      if (this.$store.state.phoneStatus === 'disconnected') {
        return 'badge-danger';
      }
      return 'badge-warning';
    },
    statusIcon() {
      if (this.$store.state.phoneStatus === 'connecting') {
        return 'is-warning';
      }
      if (this.$store.state.phoneStatus === 'disconnected') {
        return 'is-danger';
      }
      return null;
    }
  },
  methods: {
    makeCall() {
      this.$bus.$emit('makeCall', this.toNumber);
      this.show = false;
      this.showDecree91 = false
    },
    checkDecree91() {
      if (this.$store.state.user.client.country.localeCode === 'VN' && (moment().hour() < 8 || moment().hour() > 16) && !this.$store.state.user.client.overtimeCall) {
        this.showDecree91 = true
      } else {
        this.makeCall();
      }
    },
    num(key) {
      this.toNumber += key;
    },
    delNum() {
      this.toNumber = this.toNumber.substring(0, this.toNumber.length - 1);
    },
    eliminateNum() {
      this.toNumber = '';
    },
    resultStatusIcon(status) {
      if (status === 'good') {
        return 'is-success';
      }
      if (status === 'failed') {
        return 'is-danger';
      }
      return 'is-warning'
    },
    check() {
      this.checking = true;
      this.checkStepMsg = 'checkStepMicrophone';
      this.checkResults = [];

      this.checked = 1;
      let interval = setInterval(() => {
        if (this.checked < 99) {
          this.checked++;
        }
      }, 500);

      let mediaOptions = {audio: true, video: false};
      let iceConfig = {
        iceServers: [
          {
            urls: [
              `turn:${this.$store.state.user.client.host.ip}`
            ],
            username: "callio",
            credential: "collia"
          }
        ],
        iceTransportPolicy: "relay"
      };

      let testSuite = new WebRTCTest.TestSuite();

      let audioTest = new WebRTCTest.AudioTest(mediaOptions);
      audioTest.promise.then(() => {
        this.checkStepMsg = 'checkStepCallTest';
        this.checkResults.push({
          step: 'microphone',
          status: 'good',
          msg: this.$t('checkMicrophoneOk')
        });
        this.$bus.$emit('connectPhone');
      }).catch(() => {
        this.checkStepMsg = 'checkStepCallTest';
        this.checkResults.push({
          step: 'microphone',
          status: 'failed',
          msg: this.$t('checkMicrophoneFailed')
        });
      });
      testSuite.addTest(audioTest);

      let connectivityTest = new WebRTCTest.ConnectivityTest(iceConfig);
      connectivityTest.promise.then(() => {
        this.checkStepMsg = 'checkStepNetwork';
        this.checkResults.push({
          step: 'call',
          status: 'good',
          msg: this.$t('checkCallTestOk')
        });
      }).catch(() => {
        this.checkStepMsg = 'checkStepNetwork';
        this.checkResults.push({
          step: 'call',
          status: 'failed',
          msg: this.$t('checkCallTestFailed')
        });
        testSuite.stopAllTests();
      });
      testSuite.addTest(connectivityTest);

      let audioBandwidthTest = new WebRTCTest.AudioBandwidthTest({
        iceConfig: iceConfig,
        mediaOptions: mediaOptions
      });
      audioBandwidthTest.promise.then(result => {
        console.log(result);
        if (result.stats.packetLoss > 0.1 || result.stats.mbpsAvg < 0.1 || result.stats.rttAverage > 100) {
          this.checkResults.push({
            step: 'network',
            status: 'warning',
            msg: this.$t('checkNetworkWarning'),
            stats: result.stats
          });
        } else {
          this.checkResults.push({
            step: 'network',
            status: 'good',
            msg: this.$t('checkNetworkOk')
          });
        }
      }).catch(() => {
        this.checkResults.push({
          step: 'network',
          status: 'failed',
          msg: this.$t('checkNetworkFailed')
        });
      });
      testSuite.addTest(audioBandwidthTest);

      testSuite.start().then(result => {
        console.log(result);
        this.checking = false;
        clearInterval(interval);
        this.alertResult();
      }).catch(err => {
        console.log(err);
        this.checking = false;
        clearInterval(interval);
        this.alertResult();
      });
    },
    alertResult() {
      for (let result of this.checkResults) {
        console.log(result);
        if (result.status !== 'good') {
          if (result.step === 'microphone') {
            this.$swal({
              html: this.$t('alertMicrophoneFailed'),
              icon: 'error',
              toast: true,
              position: 'top-end',
              timer: 5000,
            });
          }
          if (result.step === 'call') {
            this.$swal({
              html: this.$t('alertTestCallFailed'),
              icon: 'error',
              toast: true,
              position: 'top-end',
              timer: 5000,
            });
          }
          if (result.step === 'network') {
            if (result.status === 'warning') {
              this.$swal({
                html: this.$t('alertNetworkWarning'),
                icon: 'warning',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            } else {
              this.$swal({
                html: this.$t('alertNetworkFailed'),
                icon: 'error',
                toast: true,
                position: 'top-end',
                timer: 5000,
              });
            }
          }
          break;
        }
      }
    }
  },
  mounted() {
    this.check();
    this.$bgService.get('/profile/number').then(response => {
      this.numbers = response.data;
    });
    this.$bus.$on('eliminateNum', this.eliminateNum);
  },
  beforeDestroy() {
    if (this.checkInterval) {
      clearInterval(this.checkInterval);
    }
    this.$bus.$off('eliminateNum', this.eliminateNum);
  }
}
</script>
